export default "__VITE_ASSET__Dtcn3OjX__"